import React from 'react';
import Section from '../../../HOC/Section';

const mapMarker = () => {
  return (
    <Section id='map'>
      <div>
        <iframe
          title='mapMarker'
          src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3067.6750676967376!2d39.489809627750674!3d39.74694919798802!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40700d4f2145b693%3A0x4e218488dab272d3!2sGold%20Nar%20G%C3%BCzellik%20Salonu!5e0!3m2!1str!2sus!4v1785090291820!5m2!1str!2sus'
          width='100%'
          height='450'
          frameBorder='0'
          style={{ border: 0, marginBottom: '-7px' }}
          allowFullScreen
        />
      </div>
    </Section>
  );
};

export default mapMarker;
